import {
    DataRecord,
    getMetricLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, GaugeSeriesOption } from 'echarts';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsGaugeChartProps,
    EchartsGaugeFormData,
    GaugeChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import { convertToHexColor } from '../../utils';
  
export default function transformProps(
    chartProps: EchartsGaugeChartProps,
): GaugeChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      stageColor1,
      stageColor2,
      stageColor3,
      valueFormat,
      threshold1,
      threshold2,
      rangeMin,
      rangeMax,
      showLegend
    }: EchartsGaugeFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
  
    const { setDataMask = () => {} } = hooks;
  
    const seriesData = data.map(datum => {
      return {
        name: metricLabel,
        value: datum[metricLabel]
      };
    });
  
    const series: GaugeSeriesOption[] = [
      {
        name: metricLabel,
        type: 'gauge',
        min: parseInt(rangeMin, 10),
        max: parseInt(rangeMax, 10),
        axisLine: {
          lineStyle: {
            width: 30,
            color: [
              [(parseInt(threshold1, 10) / 100), convertToHexColor(stageColor1)],
              [(parseInt(threshold2, 10) / 100), convertToHexColor(stageColor2)],
              [1, convertToHexColor(stageColor3)]
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: 'inherit'
          }
        },
        axisTick: {
          distance: -30,
          length: 8,
          lineStyle: {
            color: '#fff',
            width: 2
          }
        },
        splitLine: {
          distance: -30,
          length: 30,
          lineStyle: {
            color: '#fff',
            width: 4
          }
        },
        axisLabel: {
          color: 'inherit',
          distance: 40,
          fontSize: 20
        },
        detail: {
          valueAnimation: true,
          formatter: valueFormat,
          color: 'inherit'
        },
        // @ts-ignore
        data: seriesData,
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      legend: {
        show: showLegend
      },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      groupby
    };
}
  